import {Components} from "../components";
import 'js-loading-overlay';
import {Dropdowns} from "./Dropdowns/Dropdowns";
import RunningTotals from "./Financials/RunningTotals";
import {Alerts} from "./Alerts";
import Orders from "./Orders";

export default class Repeater {

    static JRepeater(selector) {
        // require('jquery.repeater');
        let initFunction;
        require('../lawrenceRepeater');


        if($(selector).is('[repeater]')){
            if ((initFunction = $(selector).data('init')) !== undefined){
                Repeater[initFunction]($(selector))
            }
            else{
                Repeater.initJRepeater($(selector))
            }
        }

        $('[repeater]', selector).each((key, element) => {
            if ((initFunction = $(element).data('init')) !== undefined){
                Repeater[initFunction]($(element))
            }
            else{
                Repeater.initJRepeater($(element))
            }
        });
    }

    static initJRepeater(selector) {
        let $element = $(selector);

        let options = {

            initEmpty: false,
            // createButton: '.hello',
            show: function () {

                Repeater.showItem($(this));



            },
            hide: function (deleteElement) {
                if(confirm('Are you sure you want to delete this element?')) {
                    $(this).slideUp(deleteElement);
                    $(this).remove();

                    //Only used for orders
                    RunningTotals.initRunningTotals(selector);
                }
            },
            ready: function (setIndexes) {

                // $element.find('[data-repeater-item]').each ((key, element) => {
                //     /** fixes any name issues */
                //     Repeater.nameHandler(element, key);
                // });
            },
            repeaters: [],

            isFirstItemUndeletable: false,
        };

        $('[inner-repeater]', selector).each(function (index, element) {
            $(element).addClass('innerRepeater'+index);

            options.repeaters.push({
                selector: '.innerRepeater'+index,
                show: function () {
                    Repeater.showItem($(this));

                },
                hide: function (element) {
                    hideItem($(element))
                }
            })
        });


        $element.repeater(options);

        function hideItem($element) {

            if(confirm('Are you sure you want to delete this element?')) {
                $element.slideUp();
            }
        }
    }

    static initJRepeaterProducts(selector) {
        this.initJRepeater(selector);

        // Track readiness of existing item selectize dropdowns for RunningTotals
        let $apiSelectizes = $('[data-repeater-list="items"] [data-repeater-item]:visible select[data-src]', selector);
        if ($apiSelectizes.length === 0) {
            window.orderItemsReady = true;
        } else {
            window.orderItemsReady = false;
            let loadedCount = 0;
            $apiSelectizes.on('selectize-loaded', function() {
                loadedCount++;
                if (loadedCount >= $apiSelectizes.length) {
                    window.orderItemsReady = true;
                    RunningTotals.taxAndTotals($('[data-repeater-list="items"]', selector).children());
                }
            });
        }

        /** Stops refunds carrying out this function */
        if (window.location.href.indexOf("refunds") !== -1)
            return;

        /** Ask brad sApi, refunds page */
        let $addButton = $('#addProductBtn'), $addShippingBtn = $('#addShippingBtn'),
            sAPI = $('#searchProducts').length ? $('#searchProducts')[0].selectize : null;

        $(document).ready(() => {
            $addButton.click(() => {

                JsLoadingOverlay.show();

                let value = sAPI.getValue() == '' ? sAPI.lastQuery : sAPI.getValue(),
                    itemRepeaterApi = $('[data-init="initJRepeaterProducts"]')[0].repeater;

                for (let [key, data] of Object.entries(value)) {

                    let item = sAPI.options[data],
                        newRepeaterItem = $(itemRepeaterApi.addItem(null, true)),
                        api_url,
                        product_id,
                        price_api_url;

                    Repeater.showItem(newRepeaterItem)

                    if(item.type == 'products') {

                        //The code below is for products that exist in the system
                        if (item.searchable.hasOwnProperty('product')) {
                            item.product_id = item.searchable.product.id;
                        } else {
                            item.product_id = item.searchable.id;
                        }

                        Repeater.initialiseProduct(newRepeaterItem, item);

                        api_url = '/api/products/' + item.product_id;
                        price_api_url = '/api/products/get-price/' + item.product_id;

                        axios.get(api_url, {
                            params: {
                                with: ['defaultPrice', 'categories', 'taxClass', 'bundleItems', 'bundleItems.taxClass']
                            }
                        }).then(response => {
                            let productData = response.data[0];

                            $addButton.prop('disabled', true);
                            sAPI.clear();

                            Repeater.setProductItemValues(newRepeaterItem, productData, price_api_url)


                            // BK: Bundle items now show if they out of stock.

                            let bundleItems = Repeater.addBundleItems(productData, newRepeaterItem);
                            let $productQtyInput = $('.inputQuantity', newRepeaterItem);
                            //On change of product update the quantities on the bundle items
                            $productQtyInput.on('change', function (event) {
                                let $element = $(event.currentTarget)

                                for(let [key, bundleItemDatum] of Object.entries(bundleItems)) {
                                    if (bundleItemDatum.element !== null) {
                                        let bundleItemQty = $('.inputQuantity', bundleItemDatum['element'])
                                        bundleItemQty.val($element.val()).trigger('change')

                                        if (bundleItemDatum.datum.in_stock = 1 && bundleItemDatum.datum.stock_amount >= $element.val()) {
                                            bundleItemDatum.element.remove();
                                            bundleItemDatum.element = null;
                                        }
                                    } else {
                                        if (bundleItemDatum.datum.stock_amount < $element.val()) {
                                            bundleItemDatum.element = Repeater.addBundleItem(bundleItemDatum.datum, productData, newRepeaterItem, $element.val());
                                        }
                                    }
                                }

                                RunningTotals.taxAndTotals($('[data-repeater-list="items"]').children());
                            });

                        })
                    } else {
                        /*
                        The code below
                            is for misc products
                        */

                        $(".itemType", newRepeaterItem).val('misc');

                        $(".itemName", newRepeaterItem).val(value);
                        $(".itemName", newRepeaterItem).prop('disabled', false);
                        $(".inputItemPrice", newRepeaterItem).val(0);
                        $(".inputQuantity", newRepeaterItem).val(1);
                        $(".item-description", newRepeaterItem).append('Misc Product');
                        $(".itemCost", newRepeaterItem).prop('disabled', false);
                        $(".itemCost", newRepeaterItem).show();
                        $(".inputStockLocation", newRepeaterItem).remove()
                        $(".inputSupplier", newRepeaterItem).remove();
                        $(".inputTaxClass").attr('data-selected', 1);
                        // $(".inputStockLocation", newRepeaterItem)[0].selectize.destroy();
                        // $(".inputSupplier", newRepeaterItem)[0].selectize.destroy();

                        JsLoadingOverlay.hide();
                        if (window.location.href.indexOf("refunds") <= -1){
                            RunningTotals.taxAndTotals(selector.children().last().children().last().children().last().children());
                        }
                        // $('[data-repeater-list="items"]').trigger('item-added');
                    }
                }
            });

            $('[data-repeater-delete]').click(() => {
                $('[data-repeater-list="items"]').trigger('item-deleted');
            })


            $(document).on('change load', ".inputQuantity, .inputItemPrice, [data-init='initJRepeaterProducts']", () => {
                if (window.location.href.indexOf("refunds") <= -1){
                    RunningTotals.taxAndTotals(selector.children().last().children().last().children().last().children());
                }
            })

            $addShippingBtn.click(() => {
                JsLoadingOverlay.show();

                let newRepeaterItem = selector.children().last().children().last().children().last().children().last();
                let $shippingCustomerSAPI = $('#inputShipping')[0].selectize;

                $(".itemType", newRepeaterItem).val('shipping');

                $(".inputItemPrice", newRepeaterItem).val(0);
                $(".inputQuantity", newRepeaterItem).val(1);
                $(".inputQuantity", newRepeaterItem).prop('disabled', true);
                $(".inputTaxClass", newRepeaterItem).remove();
                $(".inputStockLocation", newRepeaterItem).remove();
                $(".inputSupplier", newRepeaterItem).remove();

                let selectizeTarget = $(".itemName", newRepeaterItem).parent();
                selectizeTarget.empty()

                let newSelectize = '<lable for="inputShipping">Enter Shipping</lable><select id="inputShippingMethods" name="shipping_rate" data-init="shippingMethods" data-src=""></select>';
                selectizeTarget.append(newSelectize);


                $(".item-description", newRepeaterItem).append('Shipping');

                JsLoadingOverlay.hide();
                Dropdowns.selectize(selector);

                Orders.refreshShipping()

                $('#collapseGeneral').change(() => {
                    Orders.refreshShipping()
                });
                $('[data-repeater-delete]').on('item-deleted', () => {
                    Orders.refreshShipping();
                })
                $('[data-repeater-list="items"]').on('item-added', () => {
                    Orders.refreshShipping();
                })
            })
        })

    }

    static nameHandler (repeater, key = null) {

        /** Fixes radio button id and label for attributes */
        $(':input[type="radio"]', repeater).each((index, element) => {

            let idKey =  key ?? $(repeater).index();

            $(element).siblings('label[for="'+$(element).attr('id')+'"]').attr('for', $(element).attr('id') + '_' + idKey);
            $(element).attr('id', $(element).attr('id') + '_' + idKey);

            if(typeof $(element).data('checked') != 'undefined')
                $(element).prop('checked', true);
        });
    }

    static setProductItemValues(newRepeaterItem, productData, price_api_url = '', isBundledItemChild = false, bundledItemParent = false) {

        let $taxClassSAPI = $("select.inputTaxClass", newRepeaterItem)[0].selectize;

        if (isBundledItemChild) {
            $(".isBundledItemChild", newRepeaterItem).val(bundledItemParent.id);
        }

        $(".itemType", newRepeaterItem).val('product');
        $(".itemID", newRepeaterItem).val(productData.id);

        $(".itemName", newRepeaterItem).val(productData.title);
        $(".inputItemPrice", newRepeaterItem).val(productData.default_price.price);
        $(".inputQuantity", newRepeaterItem).val(productData.quantity ?? 1);
        $(".item-description", newRepeaterItem).append((productData.description ? productData.description.content : ''));

        if (productData.type !== 'virtual') {
            $(".inputStockLocation", newRepeaterItem).data('src', `/api/products/${productData.id}/stock`);
            $(".inputStockLocation", newRepeaterItem)[0].selectize.destroy()
            $(".inputStockLocation", newRepeaterItem).attr('data-select-first', 'true');
            Dropdowns.initSelectizeHandler($(".inputStockLocation", newRepeaterItem));
        } else {
            $(".inputStockLocation", newRepeaterItem)[0].selectize.destroy();
            $(".inputSupplier", newRepeaterItem)[0].selectize.destroy();
            $(".inputStockLocation", newRepeaterItem).remove();
            $(".inputSupplier", newRepeaterItem).remove();
        }

        $taxClassSAPI.addOption(productData.tax_class);
        $taxClassSAPI.setValue(productData.tax_class.id)


        if (price_api_url != '') {
            Repeater.setProductPrice(newRepeaterItem, price_api_url, 1)

            $('[data-repeater-list="items"]').trigger('item-added');
        }

        return newRepeaterItem;
    }

    static showItem($repeaterItem) {

        $repeaterItem.slideDown();

        $('select.selectize-template', $repeaterItem).each( function (index, element) {
            if($(element).closest('[data-repeater-item]')[0] == $repeaterItem[0])
                $(element).removeClass('selectize-template')
        })

        $repeaterItem.find('textarea.wysiwyg-template').removeClass('wysiwyg-template')

        $repeaterItem.find(':input[type="file"].filepond-template').removeClass('filepond-template')

        /** adds components js to the new repeater item */
        new Components($repeaterItem, false);

    }

    static initialiseProduct(newRepeaterItem, item, bundledItem = false) {

        let $qtyEl = $('.inputQuantity', newRepeaterItem), $stockLocationEl = $('select.inputStockLocation', newRepeaterItem),
            stockLocationApi = $stockLocationEl[0].selectize


        //On change of the quantity, refresh the stock select
        $qtyEl.on('change', function (e) {
            stockLocationApi.clear()
            stockLocationApi.clearOptions()
            stockLocationApi.destroy()
            $('.selectize-control.inputStockLocation', newRepeaterItem).remove()
            Dropdowns.initSelectizeHandler($("select.inputStockLocation", newRepeaterItem));

            //Dont reset bundled item price
            if (!bundledItem) {
                let price_api_url = `/api/products/get-price/${item.product_id}`;
                Repeater.setProductPrice(newRepeaterItem, price_api_url, $qtyEl.val())
            }

        })


        //Set direct from supplier src
        let $directFromSupplier = $('select.inputSupplier', newRepeaterItem),
            directFromSupplierAPI = $directFromSupplier[0].selectize;

        directFromSupplierAPI.clear()
        directFromSupplierAPI.clearOptions()
        directFromSupplierAPI.destroy()
        $directFromSupplier.attr('data-src', $directFromSupplier.data('src') + '/' + item.product_id)
        Dropdowns.initSelectizeHandler($directFromSupplier)
    }

    static setProductPrice($repeaterItem, price_api_url, quantity) {

        JsLoadingOverlay.hide();
        JsLoadingOverlay.show();

        axios.get(price_api_url, {
            params: {
                customer_group_id: $('#inputCustomerGroup')[0].selectize.getValue(),
                quantity: quantity
            }
        }).then((response) => {

            $(".inputItemPrice", $repeaterItem).val(response.data.price)

            if (window.location.href.indexOf("refunds") <= -1){
                RunningTotals.taxAndTotals($repeaterItem.parents('[data-repeater-list="items"]').children());
            }

            //Isn't used on muffles
            if (response.data.sale_from !== null || response.data.sale_to !== null) {
                Alerts.success('Item is on Sale');
            }
            if (response.data.min_quantity !== null) {
                Alerts.success(`Item is on a multi-buy offer of minimum quantity ${response.data.min_quantity}`);
            }
        })

        JsLoadingOverlay.hide();


    }

    static addBundleItems(productData, parentRepeaterItem) {
        let bundleItems = [], itemRepeaterApi = $('[data-init="initJRepeaterProducts"]')[0].repeater;

        //Loop through all bundle items and add additional repeater items
        for(let [key, bundleItem] of Object.entries(productData['bundle_items'])) {
            let $bundleItemRepeater = null;

            if (!bundleItem.in_stock) {

                bundleItem.product_id = bundleItem.id

                //Use repeater api function to add add silently
                $bundleItemRepeater = $(itemRepeaterApi.addItem(null, true))

                Repeater.showItem($bundleItemRepeater)

                Repeater.initialiseProduct($bundleItemRepeater, bundleItem, true);

                $bundleItemRepeater.insertAfter(parentRepeaterItem)

                //Change datum values to act as bundle item
                bundleItem.default_price = {'price': 0}
                bundleItem.quantity = bundleItem.pivot.quantity
                bundleItem.title = bundleItem.title + ' - Bundle item for (' + productData.sku + ')'

                Repeater.setProductItemValues($bundleItemRepeater, bundleItem, '', true, productData)
            }

            //Push bundle items to array. This is used later for when the quantity of the main product changes
            bundleItems.push({
                'element': $bundleItemRepeater,
                'datum': bundleItem
            })
        }

        return bundleItems;
    }

    static addBundleItem(bundleItem, productData, parentRepeaterItem, quantity = null) {
        let bundleItems = [], itemRepeaterApi = $('[data-init="initJRepeaterProducts"]')[0].repeater;

        let $bundleItemRepeater = null;

        bundleItem.product_id = bundleItem.id

        //Use repeater api function to add add silently
        $bundleItemRepeater = $(itemRepeaterApi.addItem(null, true))

        Repeater.showItem($bundleItemRepeater)

        Repeater.initialiseProduct($bundleItemRepeater, bundleItem, true);

        $bundleItemRepeater.insertAfter(parentRepeaterItem)

        //Change datum values to act as bundle item
        bundleItem.default_price = {'price': 0}
        bundleItem.quantity = quantity ?? bundleItem.pivot.quantity
        bundleItem.title = bundleItem.title + ' - Bundle item for (' + productData.sku + ')'

        Repeater.setProductItemValues($bundleItemRepeater, bundleItem, '', true, productData)

        return $bundleItemRepeater;
    }
}
